var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "city-list" }, [
    _c("div", { staticClass: "city-list__side" }, [
      _c(
        "div",
        { staticClass: "city-list__side-list" },
        [
          _vm.regionOpened
            ? _c("div", { staticClass: "city-list__back-block" }, [
                _c(
                  "a",
                  {
                    staticClass: "city-list__back",
                    attrs: { href: _vm.jsv },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("back-click")
                      }
                    }
                  },
                  [
                    _c("icon", {
                      staticClass: "city-list__inline-icon",
                      attrs: { name: "chevron", width: "5", height: "8" }
                    }),
                    _vm._v("\n          Вернуться назад\n        ")
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.regionOpened
            ? _c("div", { staticClass: "city-list__side-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "city-list__link",
                    class: { _static: _vm.regionOpened },
                    attrs: { href: _vm.jsv }
                  },
                  [_c("b", [_vm._v(_vm._s(_vm.regionName))])]
                )
              ])
            : _vm._l(_vm.popularsMarked, function(city) {
                return _c(
                  "div",
                  { key: city.location, staticClass: "city-list__side-item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "city-list__link",
                        attrs: { href: _vm.jsv },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("popular-click", city)
                          }
                        }
                      },
                      [
                        city.important
                          ? _c("b", [_vm._v(_vm._s(city.name))])
                          : [_vm._v(_vm._s(city.name))]
                      ],
                      2
                    )
                  ]
                )
              })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "city-list__objects" },
      [
        _vm._l(_vm.list, function(group, groupIndex) {
          return _vm._l(group, function(cities, letter, letterIndex) {
            return _c(
              "div",
              {
                key: groupIndex + " - " + letterIndex,
                staticClass: "city-list__group",
                attrs: { "data-letter": letter }
              },
              _vm._l(cities, function(city) {
                return _c(
                  "div",
                  { key: city.location, staticClass: "city-list__group-item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "city-list__link",
                        attrs: { href: _vm.jsv },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("region-click", city)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(city.name) + "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }